"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateGiveawayRequestStatisticsToJSON = exports.CreateGiveawayRequestStatisticsFromJSONTyped = exports.CreateGiveawayRequestStatisticsFromJSON = exports.instanceOfCreateGiveawayRequestStatistics = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CreateGiveawayRequestStatistics interface.
 */
function instanceOfCreateGiveawayRequestStatistics(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateGiveawayRequestStatistics = instanceOfCreateGiveawayRequestStatistics;
function CreateGiveawayRequestStatisticsFromJSON(json) {
    return CreateGiveawayRequestStatisticsFromJSONTyped(json, false);
}
exports.CreateGiveawayRequestStatisticsFromJSON = CreateGiveawayRequestStatisticsFromJSON;
function CreateGiveawayRequestStatisticsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'initTwitchFollowerCount': !(0, runtime_1.exists)(json, 'initTwitchFollowerCount') ? undefined : json['initTwitchFollowerCount'],
        'initYouTubeFollowerCount': !(0, runtime_1.exists)(json, 'initYouTubeFollowerCount') ? undefined : json['initYouTubeFollowerCount'],
        'initTikTokFollowerCount': !(0, runtime_1.exists)(json, 'initTikTokFollowerCount') ? undefined : json['initTikTokFollowerCount'],
        'finalTwitchFollowerCount': !(0, runtime_1.exists)(json, 'finalTwitchFollowerCount') ? undefined : json['finalTwitchFollowerCount'],
        'finalYouTubeFollowerCount': !(0, runtime_1.exists)(json, 'finalYouTubeFollowerCount') ? undefined : json['finalYouTubeFollowerCount'],
        'finalTikTokFollowerCount': !(0, runtime_1.exists)(json, 'finalTikTokFollowerCount') ? undefined : json['finalTikTokFollowerCount'],
    };
}
exports.CreateGiveawayRequestStatisticsFromJSONTyped = CreateGiveawayRequestStatisticsFromJSONTyped;
function CreateGiveawayRequestStatisticsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'initTwitchFollowerCount': value.initTwitchFollowerCount,
        'initYouTubeFollowerCount': value.initYouTubeFollowerCount,
        'initTikTokFollowerCount': value.initTikTokFollowerCount,
        'finalTwitchFollowerCount': value.finalTwitchFollowerCount,
        'finalYouTubeFollowerCount': value.finalYouTubeFollowerCount,
        'finalTikTokFollowerCount': value.finalTikTokFollowerCount,
    };
}
exports.CreateGiveawayRequestStatisticsToJSON = CreateGiveawayRequestStatisticsToJSON;
